var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "font-color"
  }, [_c('v-icon', {
    attrs: {
      "color": "black"
    }
  }, [_vm._v(_vm._s(_vm.cssKey == 'background' ? 'mdi-format-color-fill' : 'mdi-format-color-text'))]), _c('v-menu', {
    attrs: {
      "top": "",
      "nudge-bottom": "105",
      "nudge-left": "16",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-icon', _vm._g({
          staticClass: "color-icon",
          attrs: {
            "color": _vm.color
          }
        }, on), [_vm._v("mdi-color-helper")])];
      }
    }]),
    model: {
      value: _vm.menu,
      callback: function callback($$v) {
        _vm.menu = $$v;
      },
      expression: "menu"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-color-picker', {
    staticClass: "no-alpha",
    attrs: {
      "value": _vm.color,
      "flat": ""
    },
    on: {
      "input": _vm.debounceUpdate
    }
  })], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }